export const ADS_VARIANT_STORAGE_KEY = 'ads-variant'

export const FALLBACK_VARIANTS = [
  { key: 'A', type: 'inFeed', weight: 5 }, // Only InFeed
  { key: 'B', type: 'inArticle', weight: 5 }, // Only InArticle
  { key: 'C', type: 'custom', weight: 5 }, // Mix of Ad Units (InFeed, InArticle, Display)
  { key: 'D', type: 'display', weight: 5 }, // This reduce Ad Density -50%
  { key: 'DEFAULT', type: 'display', weight: 80 }
]

// Selects a percentage variant based on the weights of each variant
export const selectWeightedVariant = (variants) => {
  const totalWeight = variants.reduce((sum, v) => sum + v.weight, 0)
  const rand = Math.random() * totalWeight
  let cumulative = 0

  for (const variant of variants) {
    cumulative += variant.weight
    if (rand < cumulative) return variant
  }

  return variants[variants.length - 1] // Fallback DEFAULT variant always
}

export const getCustomAdUnit = (adPosition) => {
  const custom = {
    'menu-button': 'display',
    header: 'display',
    'content-body': 'inArticle',
    'right-side-bar': 'display',
    'explore-more-content': 'display',
    'left-side-bar': 'display',
    'explore-more': 'inFeed',
    'for-you': 'inFeed',
    'featured-content': 'inFeed'
  }
  return adPosition in custom ? custom[adPosition] : 'display'
}

export const reduceAdsInEntityMap = (entityMap) => {
  if (!entityMap || typeof entityMap !== 'object') return entityMap

  const newEntityMap = { ...entityMap }

  const adKeys = Object.entries(entityMap)
    .filter(([_, value]) => value.type === 'ew-ads')
    .sort(([keyA], [keyB]) => {
      // Sort keys naturally: numeric first, then string (e.g. acr66ub-2, acr66ub-3...)
      return keyA.localeCompare(keyB, undefined, { numeric: true, sensitivity: 'base' })
    })
    .map(([key]) => key)

  // Keep only every other ad starting with the first
  adKeys.forEach((key, index) => {
    if (index % 2 !== 0) {
      delete newEntityMap[key]
    }
  })

  return newEntityMap
}
